Ext.define('SA.model.ConditionList', {
    constructor({operator, conditions}) {
        this.operator = operator;
        this.conditions = conditions;
    },

    getConditionCount() {
        return this.getConditions().length;
    },

    getConditions() {
        return this.conditions;
    },

    getOperator() {
        return this.operator;
    },

    getUniqueAttributeIds() {
        return Ext.Array.unique(this.getConditions().map(condition => condition.getAttributeId()));
    },

    hasAttributeId(attributeId) {
        return this.getUniqueAttributeIds().includes(attributeId);
    },

    hasConditions() {
        return this.getConditionCount() > 0;
    },

    serialize() {
        return this.toPredicate().serialize();
    },

    toPredicate() {
        var operator = this.getOperator(),
            predicates = this.getConditions().map(condition => condition.toPredicate());

        return SA.Predicate.compound({operator, predicates});
    },

    toPredicateWithNotNulls() {
        var operator = this.getOperator(),
            mapCondition = condition => condition.toPredicate().and(SA.Predicate.notNull(condition.getAttributeId())),
            predicates = this.getConditions().map(mapCondition);

        return SA.Predicate.compound({operator, predicates});
    }
});